export default "__VITE_ASSET__$i96QnGa__"